import React from 'react';
import AssignFreeCard from '../Modal/AssignFreeCard';
import DeleteModal from '../../../../Modals/DeleteModal';
import {ButtonLargeTransparent} from "../../../../../components/buttons/ButtonLargeTransparent";
import Step7CardTable from '../Table/Step7CardTable';
import CustomTable from '../../../../../components/table/CustomTable';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import Step7CardApp from '../Functionality/Step7CardApp';
import CardPreview from '../../../../Cards/CardPreview';
import {TrashOutlineIcon} from '../../../../../components/buttons/IconButtons';

const Step7Card = ({
    cardsList,
    setCardsList,
    userData,
    setCardData,
    setCardDataInfo,
    componentAction,
}) => {

    const {
        selectCardForDelete,
        setSelectCardForDelete,
        excludedId,
        currentId,
        previewShow,
        isAllChecked,
        setIsAllChecked,
        deleteCardShow, setDeleteCardShow ,
        setAssignFreeCardShow, assignFreeCardShow,
        unassignCard,
        handleOnHidePreviewModal,
        handleItem
    } = Step7CardApp({
        cardsList, setCardsList, setCardData, setCardDataInfo, componentAction, userData
        });

    const { t, tableId, thead, tbody, getActionsButtons, handleCheckboxChange, handleDeleteAll } = Step7CardTable({
        data: cardsList,
        selectedList:selectCardForDelete,
        setSelectedList: setSelectCardForDelete,
        excludedId: excludedId,
        handleItem,
        setIsAllChecked
    });

    return (
        <div className='col-12'>
            <div className='my-2 d-flex justify-content-end'>
                <ButtonAction
                    id='btn_s7c_delete'
                    name='disassign'
                    className='btn-icon-delete'
                    disabled={selectCardForDelete?.length === 0}
                    Icon={TrashOutlineIcon}
                    onClick={()=>{
                        setDeleteCardShow(true);
                    }}
                />
            </div>

            <div>
                {selectCardForDelete?.length > 0 ? (
                    <div>
                        {selectCardForDelete.map((item) => {
                            <h2>{item}</h2>;
                        })}
                    </div>
                ) : null}
            </div>

            <CustomTable
                tableId={tableId}
                checkbox={true}
                checkboxTitle={"de_/_select_all"}
                isAllChecked={isAllChecked}
                onChangeCheckbox={handleDeleteAll}
                handleCheckboxChange={handleCheckboxChange}
                selectedList={selectCardForDelete}
                thead={thead}
                tbody={tbody}
                getActionsButtons={getActionsButtons}
                columnActions={true}
                withoutHeight={true}
            />

           <div className='mt-2'>
               <ButtonLargeTransparent id="btn_s7c_assign_card" click={() => {setAssignFreeCardShow(true)}} text={t("assign_card")}/>
           </div>
            <DeleteModal
                show={deleteCardShow}
                onHide={() => setDeleteCardShow(false)}
                onClickFn={() => unassignCard()}
                data={selectCardForDelete}
                title_modal={t('disassign_cards')}
                description={'are_you_sure_you_want_to_disassign'}
                element_modal={t('cards')}
            />
            <AssignFreeCard
                show={assignFreeCardShow}
                onHide={() => {
                    setAssignFreeCardShow(false);
                }}
                userData={userData}
                cardsAssign={cardsList}
                setCardsAssign={setCardsList}
                componentAction={componentAction}
            />
            {previewShow && (
                <CardPreview
                    open={previewShow}
                    onHide={(e) => {
                        handleOnHidePreviewModal(e);
                    }}
                    currentId={currentId}
                />
            )}

        </div>
    );
};

export default Step7Card;
